import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { PagedList, PermissionKey, PermissionModel, PermissionResourceService, SavePermissionRequest, SaveResult } from 'hx-services';

@Injectable({providedIn: 'root'})
export class PermissionService {
  constructor(
    private permissionResource: PermissionResourceService,
  ) {
  }

  getPermissions(params?: {
    page?: number,
    limit?: number,
    sort?: string[],
    containerId?: number,
    containerClass?: string,
    key?: PermissionKey,
  }): Promise<PagedList<PermissionModel>> {
    return firstValueFrom(this.permissionResource.getPermissionList(
      params?.containerClass,
      params?.containerId,
      params?.key,
      params?.limit,
      params?.page,
    ));
  }

  getPermissionById(id: number): Promise<PermissionModel> {
    return firstValueFrom(this.permissionResource.getPermissionById(id));
  }

  savePermission(req: SavePermissionRequest): Promise<SaveResult> {
    return firstValueFrom(this.permissionResource.savePermission(req));
  }

  removePermission(id: number): Promise<void> {
    return firstValueFrom(this.permissionResource.removePermissionById(id));
  }

  setActive(id: number, active: boolean): Promise<void> {
    return firstValueFrom(this.permissionResource.setPermissionActiveById(id, {active: active}));
  }
}

